import styled from "styled-components";
import { colorsPalettes, mixins, fonts } from "@similarweb/styles";
import { Button, ButtonLabel } from "@similarweb/ui-components";

export const ModalHeading = styled.h2`
    ${mixins.setFont({
        $size: 20,
        $weight: 500,
        $color: colorsPalettes.carbon[500],
        $family: fonts.$dmSansFontFamily,
    })};
    line-height: 24px;
    margin: 0 0 36px 0;
`;
export const ModalDetails = styled.p`
    ${mixins.setFont({ $size: 16, $color: colorsPalettes.carbon[400] })};
    text-align: center;
    line-height: 20px;
    margin: 0 0 26px;
`;
export const StyledCancelButton = styled(Button)`
    margin: auto 0 0 auto;

    ${ButtonLabel} {
        ${mixins.setFont({ $size: 14, $weight: 700, $family: fonts.$dmSansFontFamily })};
        line-height: 20px;
    }
`;
export const loaderStyles = {
    svg: { stroke: colorsPalettes.midnight[50], strokeWidth: "4", r: 21, cx: "50%", cy: "50%" },
    style: { width: 46, height: 46, margin: "0 auto" },
};
export const modalStyled = {
    content: {
        width: "400px",
        height: "285px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
    },
} as const;
